import React from 'react';
import { StyleSheet, View } from 'react-native';

import { BodyText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemNutritionItem = (props: Props) => {
  const { label, value } = props;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.container}>
      <BodyText bold sizeMatch={['12', '14']}>
        {value}
      </BodyText>

      <BodyText sizeMatch={['12', '14']} style={styles.label}>
        {label}
      </BodyText>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignItems: 'baseline',
    flexDirection: 'row',
    gap: theme.spacing['1'],
  },
  label: {
    color: theme.colors.CHARCOAL,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  label: string;
  value: string | number;
};
